// Shared filter-pill predicate for the /inbox page and the account Shared Inbox tab.
import type { UnifiedEmail } from "./types";

export type EmailPill = "all" | "unread" | "mine" | "unclaimed" | "starred";

export function matchesPill(email: UnifiedEmail, pill: EmailPill, currentUserId: string): boolean {
  switch (pill) {
    case "unread":
      return !email.isRead;
    case "mine":
      return email.assignedToUserId === currentUserId;
    case "unclaimed":
      return !email.taskStatus && !email.assignedToUserId;
    case "starred":
      return email.flagStatus === "flagged";
    default:
      return true;
  }
}
